"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cittareale": {
    "1d0da4f3": [{
      "hkey": "117550e6",
      "slug": "cittareale",
      "name": "Cittareale",
      "primary": true,
      "skipSearch": false
    }],
    "cupello": [{
      "hkey": "117550e6",
      "slug": "cittareale",
      "name": "Cittareale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cc1fad15": [{
      "hkey": "117550e6",
      "slug": "cittareale",
      "name": "Cittareale",
      "primary": true,
      "skipSearch": false
    }],
    "folcara": [{
      "hkey": "117550e6",
      "slug": "cittareale",
      "name": "Cittareale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a421f840": [{
      "hkey": "0c3c7ad3",
      "slug": "marianitto",
      "name": "Marianitto",
      "primary": true,
      "skipSearch": false
    }],
    "marianetto": [{
      "hkey": "0c3c7ad3",
      "slug": "marianitto",
      "name": "Marianitto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "597b71e1": [{
      "hkey": "117550e6",
      "slug": "cittareale",
      "name": "Cittareale",
      "primary": true,
      "skipSearch": false
    }],
    "martinello": [{
      "hkey": "117550e6",
      "slug": "cittareale",
      "name": "Cittareale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ae4ef56d": [{
      "hkey": "117550e6",
      "slug": "cittareale",
      "name": "Cittareale",
      "primary": true,
      "skipSearch": false
    }],
    "matrecciano": [{
      "hkey": "117550e6",
      "slug": "cittareale",
      "name": "Cittareale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3e724194": [{
      "hkey": "117550e6",
      "slug": "cittareale",
      "name": "Cittareale",
      "primary": true,
      "skipSearch": false
    }],
    "vezzano": [{
      "hkey": "117550e6",
      "slug": "cittareale",
      "name": "Cittareale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;